import type { MediaCounts } from "~/composables/useMediaCounts"

export function useHasContent(
  mediaCounts: MaybeRefOrGetter<MediaCounts | undefined>,
  hasIntroPages: MaybeRefOrGetter<boolean>,
) {
  return computed(() => {
    const counts = toValue(mediaCounts)
    return toValue(hasIntroPages) || (
      !!counts && (
        counts.articles > 0 ||
        counts.videos > 0 ||
        counts.podcasts > 0 ||
        counts.quizes > 0
      )
    )
  })
}
